export default __webpack_public_path__ + "static/fin-trade-retail-7bb159102205ec66461e7b11161a0197.png";